<template>
  <div class="imap-wrap">

    <!-- Initial load -->
    <div class="tab-loading" v-if="loading">
      <i class="fa fa-spinner fa-spin"></i> Loading configuration…
    </div>

    <template v-else>
      <form @submit.stop.prevent>

        <div class="form-group">
          <label>Server <span class="req">*</span></label>
          <input type="text" class="field" v-model="imap_server"
            :class="{ 'field-err': errors['imap_server'] }" placeholder="e.g. imap.gmail.com" />
          <span v-if="errors['imap_server']" class="err-msg">{{ errors["imap_server"][0] }}</span>
        </div>

        <div class="form-group">
          <label>Username <span class="req">*</span></label>
          <input type="text" class="field" v-model="username"
            :class="{ 'field-err': errors['username'] }" placeholder="you@example.com" />
          <span v-if="errors['username']" class="err-msg">{{ errors["username"][0] }}</span>
        </div>

        <div class="form-group">
          <label>Password <span class="req">*</span></label>
          <div class="pw-wrap" :class="{ 'pw-wrap-err': errors['password'] }">
            <input :type="password_type" class="pw-field" v-model="password"
              placeholder="••••••••" />
            <button type="button" class="pw-eye" @click="showPassword()">
              <i :class="password_type === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
            </button>
          </div>
          <span v-if="errors['password']" class="err-msg">{{ errors["password"][0] }}</span>
        </div>

        <div class="form-group">
          <label>From Email Address <span class="req">*</span></label>
          <input type="email" class="field" v-model="from_email"
            :class="{ 'field-err': errors['from_email'] }" placeholder="noreply@example.com" />
          <span v-if="errors['from_email']" class="err-msg">{{ errors["from_email"][0] }}</span>
        </div>

        <div class="form-group">
          <label>Subject</label>
          <input type="text" class="field" v-model="subject"
            :class="{ 'field-err': errors['subject'] }" placeholder="Default email subject" />
          <span v-if="errors['subject']" class="err-msg">{{ errors["subject"][0] }}</span>
        </div>

      </form>

      <div class="form-footer">
        <button class="btn-test" @click="testConnection()" ref="kt_test_connections">
          <i class="fa fa-envelope"></i> Test IMAP Connection
        </button>
        <button class="btn-save" @click="onSubmit()" ref="kt_save_configure">
          <i class="fa fa-check"></i> Save
        </button>
      </div>
    </template>

  </div>
</template>

<script>
import {
  FETCH_IMAP_CONFIG,
  UPDATE_IMAP_CONFIG,
  TEST_IMAP_CONFIG
} from "@/core/services/store/actions.type";

export default {
  data() {
    return {
      loading: true,
      errors: [],
      id: 0,
      imap_server: "",
      username: "",
      password: "",
      from_email: "",
      subject: "",
      password_type: "password"
    };
  },
  created() {
    this.$store.dispatch(FETCH_IMAP_CONFIG).then(data => {
      if (data.success == true) {
        this.id          = data.data.id;
        this.imap_server = data.data.imap_server;
        this.username    = data.data.username;
        this.password    = data.data.password;
        this.from_email  = data.data.from_email;
        this.subject     = data.data.subject;
      }
      this.loading = false;
    }).catch(() => { this.loading = false; });
  },
  methods: {
    showPassword() {
      this.password_type = this.password_type === "password" ? "text" : "password";
    },
    testConnection() {
      this.errors = [];
      const btn = this.$refs["kt_test_connections"];
      btn.disabled = true;
      btn.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store.dispatch(TEST_IMAP_CONFIG, {
        imap_server: this.imap_server,
        username: this.username,
        password: this.password
      }).then(data => {
        btn.classList.remove("spinner", "spinner-light", "spinner-right");
        btn.disabled = false;
        this.$toastr.s(data.msg);
      }).catch(err => {
        btn.classList.remove("spinner", "spinner-light", "spinner-right");
        btn.disabled = false;
        this.errors = err.error || "Error";
        this.$toastr.e("Connection test failed");
      });
    },
    onSubmit() {
      this.errors = [];
      const btn = this.$refs["kt_save_configure"];
      btn.disabled = true;
      btn.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store.dispatch(UPDATE_IMAP_CONFIG, {
        id_: this.id,
        imap_server: this.imap_server,
        username: this.username,
        password: this.password,
        from_email: this.from_email,
        subject: this.subject
      }).then(data => {
        btn.classList.remove("spinner", "spinner-light", "spinner-right");
        btn.disabled = false;
        if (this.id == 0) this.id = data.id;
        this.$toastr.s(data.msg);
      }).catch(err => {
        btn.classList.remove("spinner", "spinner-light", "spinner-right");
        btn.disabled = false;
        this.errors = err.error;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$green:  #276749;
$orange: #F58020;
$dark:   #0d1b3e;
$border: #dde2ec;

.imap-wrap { font-family: $font; }

/* Loading */
.tab-loading {
  display: flex; align-items: center; gap: 10px;
  padding: 40px 0; color: #8a94a6; font-size: 13px;
  i { color: $blue; font-size: 18px; }
}

/* Form */
.form-group { margin-bottom: 18px; }

label {
  display: block;
  font-size: 11px; font-weight: 700;
  color: #4a5568;
  text-transform: uppercase; letter-spacing: 0.4px;
  margin-bottom: 6px;
}
.req { color: #e53e3e; }

.field {
  display: block; width: 100%;
  height: 38px;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 13px; font-family: $font; color: $dark;
  background: #fff;
  transition: border-color 0.15s;
  box-shadow: none; outline: none;
  &:focus { border-color: $blue; }
  &.field-err { border-color: #e53e3e; }
}

/* Password */
.pw-wrap {
  display: flex;
  border: 1.5px solid $border;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s;
  &:focus-within { border-color: $blue; }
  &.pw-wrap-err { border-color: #e53e3e; }
}
.pw-field {
  border: none; border-radius: 0; flex: 1;
  height: 38px; padding: 0 12px;
  font-size: 13px; font-family: $font; color: $dark;
  outline: none; background: #fff;
}
.pw-eye {
  width: 40px; height: 38px;
  border: none; background: #fff;
  color: #9aa0ae; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; flex-shrink: 0;
  &:hover { color: $blue; }
}

.err-msg { font-size: 11px; color: #e53e3e; margin-top: 3px; display: block; }

/* Footer */
.form-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 24px;
  margin-top: 8px;
  border-top: 1px solid #f0f3fa;
}

.btn-test {
  display: inline-flex; align-items: center; gap: 7px;
  height: 38px; padding: 0 20px; border-radius: 8px;
  border: 1.5px solid $orange; background: transparent;
  color: $orange; font-size: 13px; font-weight: 600; font-family: $font;
  cursor: pointer; transition: background 0.15s;
  i { font-size: 12px; }
  &:hover { background: #fff5ec; }
  &:disabled { opacity: 0.6; cursor: default; }
}

.btn-save {
  display: inline-flex; align-items: center; gap: 7px;
  height: 38px; padding: 0 24px; border-radius: 8px;
  border: none; background: $green;
  color: #fff; font-size: 13px; font-weight: 600; font-family: $font;
  cursor: pointer; transition: background 0.15s;
  i { font-size: 12px; }
  &:hover { background: #1d5230; }
  &:disabled { opacity: 0.6; cursor: default; }
}
</style>
